import type { CSSProperties } from 'react';

import COLORS from '../../theme/colors';

type LoaderProps = {
  color?: string;
  size?: number | string;
  stroke?: number | string;
  radius?: number | string;
  style?: CSSProperties;
};

const Loader = ({
  color = COLORS.fossaSlateBlue,
  size = 50,
  stroke = 3,
  radius = 15,
  style,
}: LoaderProps) => (
  <div className="text-center" style={style} data-testid="loader">
    <svg
      className="loader"
      style={style}
      width={size}
      height={size}
      viewBox="25 25 50 50"
    >
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        strokeWidth={stroke}
        stroke={color}
      />
    </svg>
  </div>
);

export default Loader;
